module.exports = __webpack_public_path__ + "static/img/Calendar.841695a4.svg";